module.exports = __webpack_public_path__ + "static/img/adviser.cd9f7240.png";